<template>
	<!-- <h3 class="text-center museum-titel-test">{{ t(`quiz.post_title`)}}</h3> -->
	<h1 class="text-center text-white" style="font-size: 80px; padding-top: 300px; padding-left: 50px; padding-right: 50px;">{{ t(`quiz.title`)}}</h1>
	<p class="text-center text-white" style="font-size: 40px;">
		{{ t(`quiz.text`)}}
	</p>
	<div class="d-flex w-100" style="margin-top: 50px;">
		<QuizButton text="Start Quiz" link="Quiz" class="mx-auto"></QuizButton>
	</div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import QuizButton from "@/components/quiz/QuizButton.vue";

export default {
	name: "QuizStart",
	components: {
		QuizButton
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
};
</script>